

const projectData = [
  {
    id: 1,
    isBlog: false,
    title: "Audience Pool",
    description:
      "A live App Store platform connecting brands with audiences for campaigns and tenders. Built across mobile and web platforms with an in-app wallet system, real-time currency conversion, and multi-country support using live exchange rate APIs.",
    ghLink: "https://github.com/shivamtpathi",
    noGithub: true, // GitHub button hide rahega
    demoLink: "https://apps.apple.com/in/app/audience-pool/id6747374898",
    techStack: [
      "React Native",
      "React.js",
      "Next.js",
      "Node.js",
      "Express.js",
      "MongoDB"
    ]
  },

  {
    id: 2,
    isBlog: false,
    title: "Movisy",
    description:
      "A movie discovery platform featuring movie listings, ratings, reviews, and search functionality. Built with React Native and a custom Node.js backend. Redis caching was implemented to improve performance and reduce redundant API requests.",
    ghLink: "https://github.com/shivamtpathi",
    noGithub: true,
    demoLink: "#", // ya actual live URL agar hai
    techStack: [
      "React Native",
      "Node.js",
      "Express.js",
      "MongoDB",
      "Redis"
    ]
  },

  {
    id: 3,
    isBlog: false,
    title: "ResumeForge",
    description:
      "A modern ATS-friendly resume builder with real-time preview, PDF export, responsive layouts, LocalStorage persistence, and professional resume templates.",
    ghLink: "https://github.com/shivamtpathi",
    noGithub: false,
    demoLink: "https://resumeforge-drab.vercel.app/",
    techStack: [
      "Next.js",
      "TypeScript",
      "Tailwind CSS",
      "shadcn/ui",
      "jsPDF"
    ]
  }
,
  {
    id: 4,
    isBlog: false,
    title: "AmazonClone",
    description:
"Introducing our sleek React Native Amazon Clone – your go-to destination for effortless online shopping. Explore a wide array of products in a user-friendly interface. This clone ensures a smooth browsing experience, allowing you to add items to your cart and proceed through a secure checkout process. Revolutionize your online shopping with our intuitive and efficient Amazon Clone.",    
ghLink: "https://github.com/shivamtpathi",
    noGithub:false,
    demoLink: "https://drive.google.com/drive/folders/1vzXWWBHXLUswOI8jtSOXuikw1kmqvKlo?usp=sharing",
    techStack:['React Native with TypeScript | Sanity CMS ','GROQ, E-cart Logic','Formik with Yup | Firebase']
  },
  {
    id: 5,
    isBlog: false,
    title: "Food Delivery App",
    description:
    "Introducing a cutting-edge React Native food delivery app seamlessly integrated with Sanity CMS, GROQ, Redux, and E-cart Logic. Elevate your dining experience as users effortlessly browse restaurants, explore menus, place orders, and track deliveries. The app guarantees a sleek and intuitive interface, revolutionizing the way we indulge in the joy of food ordering and delivery.",
    ghLink: "https://github.com/shivamtpathi",
    noGithub:false,
    demoLink: "https://drive.google.com/drive/folders/1R5__fO99BCAaBtUr8qKJ7rrbspg15U2l?usp=sharing",
    techStack:['React Native | Sanity CMS | Firebase','GROQ','Redux, E-cart Logic']
  },
  {
    id: 6,
    isBlog: false,
    title: "Todo App",
    description:
    "Introducing our Todo App – your simple solution for managing tasks. Create, edit, and delete todos with ease. Stay organized effortlessly with our user-friendly interface. Your go-to app for efficient task management. Plus, enjoy the added convenience of push notifications to keep you on track.",
    ghLink: "https://github.com/shivamtpathi",
    noGithub:false,
    demoLink: "https://drive.google.com/drive/folders/1OkwlaxOtHhtvSYhgZlbtiQGlBEybTasC?usp=drive_link",
    techStack:['React Native with TypeScript | Firebase','push notifications','Formik with Yup',]
  },
  {
    id: 7,
    isBlog: false,
    title: "Quiz App",
    description:
    "Welcome to our Quiz App – the ultimate destination for a fun and challenging quiz experience! Answer 10 engaging questions, and if you're unsure about any, feel free to skip. At the end, discover your quiz prowess with a detailed result, complete with a star rating. Dive into the world of knowledge and enjoy a rewarding quiz journey!",
    ghLink: "https://github.com/shivamtpathi",
    noGithub:false,
    demoLink: "https://drive.google.com/drive/folders/1qY0oXcl_CKRQQ6Fg24OipaY7-jWaL4Zg?usp=drive_link",
    techStack:['React Native ','react-native-ratings','API integration']
  },
  {
    id: 8,
    isBlog: false,
    title: "Invoice App",
    description:
    "Introducing our Invoice App – effortlessly create and manage professional invoices. Streamline your business finances with a user-friendly interface, ensuring accuracy and transparency. Stay organized with easy tracking of invoice status and payments. Simplify your billing process and focus on growing your business with our Invoice App.",
    ghLink: "https://github.com/shivamtpathi",
    noGithub:false,
    demoLink: "https://drive.google.com/drive/folders/1E0ysJ1vBpPrntg3mJCbusLpOJz0oAMlQ?usp=sharing",
    techStack:['React Native ','react-native-html-to-pdf', "react-native-share, dateformat"]
  },
];

export default  projectData ;

// {
//   id: 1,
//   imgPath: msdl,
//   isBlog: false,
//   title: "Digital Library",
//   description:
//     "A digital library is an online platform that allows users to upload and share audio, video, PDF files, and articles. It offers features like subscription-based push notifications, bookmarks, and easy downloading for users to access and manage the content.",
//   ghLink: "",
//   noGithub:true,
//   demoLink: "https://play.google.com/store/apps/details?id=net.socialwell.msdl",
//   appStore:"https://apps.apple.com/us/app/msdl/id6451332214",
//   techStack:['Multi-langauge support,GraphQL, React Native, Redux','Push Notification, Subscription, Bookmark ','File System, History, Device Utilities ']
// },
// {
//   id: 2,
//   imgPath: cf,
//   isBlog: false,
//   title: "City Furnish",
//   description:
//     "A furniture e-commerce app allows users to browse, purchase, and manage furniture products directly from their mobile devices. It offers a convenient interface, detailed product information, secure payment options, and order tracking for a seamless shopping experience.",
//   ghLink: "",
//   noGithub:true,
//   appStore:"https://apps.apple.com/in/app/cityfurnish/id1526271477",
//   demoLink: "https://play.google.com/store/apps/details?id=com.cityfurnish",
//   techStack:['REST API | React Native | Redux','Push Notification Deep Linking','Social Login - Google, Facebook | Device Utilities ']
// },
// {
//   id: 3,
//   imgPath: emp,
//   isBlog: false,
//   title: "Employee Management Portal",
//   description:
//     "The Employee Management Portal app is a digital platform designed to streamline and simplify various aspects of managing employees within an organization. It serves as a central hub for both employees and management, providing a range of features and functionalities to enhance communication, efficiency, and productivity.",
//   ghLink: "",
//   noGithub:true,
//   demoLink: "https://play.google.com/store/apps/details?id=com.d3v_emportal&hl=en-IN",
//   techStack:['React Native | Redux','REST Api , Push Notification, Real time sync','Real time chat']
// },


// {
//   id: 4,
//   imgPath: ff,
//   isBlog: false,
//   title: "Fitness Freaks",
//   description:
//     "The Fitness Freak app is a comprehensive health and fitness application designed for athletes to monitor their health progress and connect with their coaches. This app provides athletes with a range of features to help them track their fitness goals, maintain a healthy lifestyle, and communicate with their coaches effectively.",
//   ghLink: "https://github.com/Ritik5Prasad/FitnessFreaks",
//   noGithub:false,
//   demoLink: "https://drive.google.com/file/d/15x353GXsQrQ_5S0J1Yl9I1Rnt0Hjd1Dp/view?usp=sharing",
//   techStack:['Firebase | React Native | Redux','Push Notification','Chat | Device Utilities ']
// },
// {
//   id: 5,
//   imgPath: foodapp,
//   isBlog: false,
//   title: "Food Delivery App",
//   description:
//     "This is a food delivery app built using React Native, Sanity CMS, GROQ, Redux, and E-cart Logic. Users can browse restaurants, view menus, place orders, and track delivery. The app ensures a smooth and intuitive experience for food ordering and delivery.",
//   ghLink: "https://github.com/Ritik5Prasad/Deliveroo-clone",
//   noGithub:false,
//   demoLink: "https://drive.google.com/file/d/1yBFJ9I4BJKcvCmKa4DFNkUwSPCTyLqmO/view?usp=sharing",
//   techStack:['React Native | Sanity CMS','GROQ','Redux, E-cart Logic']
// },